import BlogIndex from '../../components/blog/blogIndex'
export default BlogIndex
